import React, { useState } from 'react'
import { useAppDispatch } from './useAppDispatch'
import { AlertManager, useAlert } from 'react-alert'
import useIsMounted from './useIsMounted'

interface UseDefaultComponentTools {
	loading: boolean
	setLoading: React.Dispatch<React.SetStateAction<boolean>>
	dispatch: ReturnType<typeof useAppDispatch>
	alert: AlertManager
	isMounted: () => boolean
}

export const useDefaultComponentTools = (
	defaultLoadingValue?: boolean
): UseDefaultComponentTools => {
	const [loading, setLoading] = useState<boolean>(defaultLoadingValue || false)
	const dispatch = useAppDispatch()
	const alert = useAlert()
	const isMounted = useIsMounted()

	return {
		loading,
		setLoading,
		dispatch,
		alert,
		isMounted,
	}
}
